import { createSlice } from '@reduxjs/toolkit';
import type { ConfigState } from '@brighterion/types/config';

const initialState: ConfigState = {
    data: undefined,
    appInfo: undefined
};

const configSlice = createSlice({
    name: 'config',
    initialState,
    reducers: {}
});

export default configSlice.reducer;
